import { PageFeed } from 'model/indexTS';
import { ButtonIcon } from 'ui-library/button';
import { TranslateInterface } from 'utils/translation';
import ClassNames from '@streamloots/classnames';
import trackEventManager from 'utils/event-manager';
import theme from './feed-list.scss';
import { useShareFeed } from '../../useShareFeed';

const classNames = ClassNames(theme);

export interface ShareButtonProps extends TranslateInterface {
  feed: PageFeed;
}

export const ShareButton = ({ feed, t }: ShareButtonProps): JSX.Element => {
  const { showShareDialog } = useShareFeed();

  const handleClick = () => {
    trackEventManager.feedClicked({
      location: 'feed content',
      content_id: feed._id,
      like_count: feed.summary.reactionCount,
      comment_count: feed.summary.commentCount,
      button: 'share',
    });
    showShareDialog(feed);
  };

  return (
    <ButtonIcon
      onClick={handleClick}
      variant="ghost"
      className={classNames('feed-detail__footer__label-btn')}
      labelClass={classNames('feed-detail__footer__label-btn-label')}
      icon="base_share"
      iconClass={classNames('feed-detail__footer__button__icon')}
    >
      {t('common:share')}
    </ButtonIcon>
  );
};
